import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "../utils/authnicate";

/**
 * Update an existing SPOC user.
 * PUT api/SpocCreation/update-spoc
 */
export const updateSpocAction = async (userId, formData) => {
  const user = getUserData();
  const payload = {
    userId: Number(userId) || 0,
    userName:
      formData.employeeName?.trim() || formData.employeeId?.trim() || "",
    email: formData.email?.trim() || "",
    lobType: formData.lob?.trim() || "",
    department: formData.department?.trim() || "",
    modifiedBy: user?.email || user?.userName || "admin",
  };

  console.log(
    "[updateSpoc] → PUT update-spoc | userId:",
    userId,
    "| payload:",
    payload,
  );

  try {
    const response = await apiClient.put(ATP_API_URL.SPOC_UPDATE, payload);

    console.log("[updateSpoc] ← response:", response?.status, response?.data);

    if (response?.status === 200) {
      if (response.data?.success === false) {
        console.warn(
          "[updateSpoc] API returned success=false:",
          response.data.message,
        );
        return {
          success: false,
          message: response.data.message || "Failed to update SPOC",
        };
      }
      return {
        success: true,
        message: response.data?.message || "SPOC updated successfully",
        data: response.data,
      };
    }

    console.error("[updateSpoc] Unexpected status:", response?.status);
    return { success: false, message: "Failed to update SPOC" };
  } catch (error) {
    console.error(
      "[updateSpoc] Error:",
      error?.response?.data || error.message,
    );
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error.message ||
        "Failed to update SPOC",
    };
  }
};
